<ng-container *transloco="let t">
  @if (store.status() === status.Loaded) {
    <main class="pl-4 pr-4 pt-4">
      <div class="logo">
        @if (store.data()?.logo) {
          <img style="height: 80px" [src]="store.data()?.logo?.thumbnailUrl" alt="" />
        } @else {
          <anihis-name-initials
            [name]="store.data()?.name"
            [width]="'60px'"
            [height]="'60px'"
            [fontSize]="'48px'"
          ></anihis-name-initials>
        }
      </div>

      <div
        class="column w-full"
        style="gap: 16px; overflow: auto; height: 85vh; padding-bottom: 56px"
      >
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>{{ t('Name Clinic') }}</mat-card-title>
          </mat-card-header>
          <mat-card-content class="justify-content-space-between">
            {{ store.data()?.name }}
          </mat-card-content>
        </mat-card>

        @if (store.data()?.contact?.phoneNumber) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Phone Number') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.phoneNumber }}
              </div>
              <mat-icon
                class="phone-icon"
                (click)="redirectToPhoneNumber()" role="button" tabindex="0" (keydown.enter)="redirectToPhoneNumber()" (keydown.space)="redirectToPhoneNumber()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }
        @if (store.data()?.contact?.mobileNumber) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Mobile Number') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.mobileNumber }}
              </div>
              <mat-icon
                class="phone-icon"
                (click)="redirectToMobileNumber()" role="button" tabindex="0" (keydown.enter)="redirectToMobileNumber()" (keydown.space)="redirectToMobileNumber()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }

        @if (store.data()?.email) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Email') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.email }}
              </div>
              <mat-icon
                class="email-icon"
                (click)="redirectToEmail()" role="button" tabindex="0" (keydown.enter)="redirectToEmail()" (keydown.space)="redirectToEmail()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }

        @if (store.data()?.contact?.street) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Address Clinic') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.street }}
              </div>
              <mat-icon
                class="next-arrow-icon"
                (click)="redirectToMap()" role="button" tabindex="0" (keydown.enter)="redirectToMap()" (keydown.space)="redirectToMap()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }

        @if (store.data()?.contact?.instagram) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Instagram') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.instagram }}
              </div>
              <mat-icon
                class="next-arrow-icon"
                (click)="redirectToInstagram()" role="button" tabindex="0" (keydown.enter)="redirectToInstagram()" (keydown.space)="redirectToInstagram()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }

        @if (store.data()?.contact?.facebook) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Facebook') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.facebook }}
              </div>
              <mat-icon
                class="next-arrow-icon"
                (click)="redirectToFacebook()" role="button" tabindex="0" (keydown.enter)="redirectToFacebook()" (keydown.space)="redirectToFacebook()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }
        @if (store.data()?.contact?.linkedIn) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Linkedin') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.linkedIn }}
              </div>
              <mat-icon
                class="next-arrow-icon"
                (click)="redirectToLinkedIn()" role="button" tabindex="0" (keydown.enter)="redirectToLinkedIn()" (keydown.space)="redirectToLinkedIn()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }

        @if (store.data()?.contact?.website) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>{{ t('Website') }}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="justify-content-space-between">
              <div>
                {{ store.data()?.contact?.website }}
              </div>
              <mat-icon
                class="next-arrow-icon"
                (click)="redirectToWebsite()" role="button" tabindex="0" (keydown.enter)="redirectToWebsite()" (keydown.space)="redirectToWebsite()"
              ></mat-icon>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </main>
  } @else {
    <div
      style="
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <anihis-loading-spinner [size]="'medium'"></anihis-loading-spinner>
    </div>
  }
</ng-container>
